import { useEffect, useState } from "react";

import { TIME_INTERVALS } from "shared/lib/constants/time";

export const useThrottledValue = <T>(
  value: T,
  delay: number = TIME_INTERVALS.ONE_HUNDRED_MILLISECONDS * 4
) => {
  const [throttledValue, setThrottledValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setThrottledValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return throttledValue;
};
